import React, { useEffect } from "react";
import { useForm } from 'react-hook-form';

// components
import { Card, CardBody, Row, Col, Container, FormGroup, Form, Input, Button } from "reactstrap";
import { showMessage } from "services/message.js";
 

// services
import { api_PUT } from "services/api_service.js";
import { useAuth } from "context/auth";

export default function Login({ history }) {
    const { setLoading, signOut, setupSistema } = useAuth();

    const { register, handleSubmit } = useForm({ mode: "onBlur" });

    useEffect(() => {
        signOut(false, null);
    }, []);

    const onSubmit = (data) => {
        let new_password = Math.random().toString(36).slice(-8);
        let json_post = {
            email: data.email,
            password: new_password
        }

        setLoading(true);
        api_PUT(`usuario/EsqueceuSenha`, json_post)
            .then(result => showMessage("Atenção", "Uma senha temporária foi enviada para seu email", 'success', function () { history.push("/auth/login") }))
            .catch(err => showMessage("Atenção", err.message, 'error', null))
            .finally(() => setLoading(false));
    }
    return (
        <>
            <div className="content" style={{ marginTop: "50px" }}>
                <div className="border-login">
                    <Card className="card-login">
                        <CardBody>
                            <Container className="text-center">
                                <h3 className="titulo-solicitacao">BEM VINDO</h3>
                            </Container>
                            <Container style={{ marginTop: "30px" }}>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <Row>
                                        <Col lg="6" md="12">
                                            <div className="text-center">
                                                <h4 className="title" style={{ margin: "0px" }}>Gestão de Cadastro - {setupSistema && setupSistema.identificacao}</h4>
                                                <img src={require("assets/img/mascote.png")} />
                                            </div>
                                        </Col>
                                        <Col lg="6" md="12">
                                            <Row>
                                                <Col md="12">
                                                    <div className="formPrincipal">
                                                        <Form>
                                                            <Row>
                                                                <Col md="12" lg="12">
                                                                    <FormGroup>
                                                                        <b><label>Digite seu Email para receber uma senha temporária</label></b>
                                                                        <Input type="email" name="email" maxLength="200" innerRef={register()} />
                                                                    </FormGroup>
                                                                    <a style={{ cursor: "pointer" }} onClick={() => { history.push("/auth/login"); }}>Voltar</a>
                                                                </Col>
                                                            </Row>
                                                        </Form>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <div className="text-right">
                                                <Button color="success" className="btn-mobile" type="submit">Enviar Email  <i className="fas fa-check"></i></Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </form>
                            </Container>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </>
    );
}